var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTractor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm11.499 1a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm-11.5 1.571a1.928 1.928 0 1 0 0 3.857 1.928 1.928 0 0 0 0-3.857ZM16 14.667a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666ZM5.999 0C7.46 0 8.527.668 9 2l.851 4.256c1.433.096 2.82.217 4.147.362V2h2L16 6.862c.962.13 1.886.275 2.767.435.779.141 1.232.614 1.232 1.284L20 13a4.995 4.995 0 0 0-4-1.997A5.001 5.001 0 0 0 11.099 15h-1.12a5.499 5.499 0 0 0-5.478-4.994 5.482 5.482 0 0 0-3.377 1.157H.004v-1.18L0 7.327c-.002-.597.37-1.18.999-1.302V1a1 1 0 0 1 1-1h4Zm1 2H3v4h.75c1.386.027 2.749.073 4.079.139L6.999 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractor);
export default __webpack_public_path__ + "static/media/tractor.979d2c2ca79dc992fef5835a51ad0e03.svg";
export { ForwardRef as ReactComponent };